<template>
  <div>
    <!-- 购买会员弹窗 -->
    <el-dialog
      custom-class="no-title-dialog1"
      :visible.sync="isDialogShow"
      :before-close="closeDialog"
      width="800px"
      center
      @open="handleOpen"
      :close-on-click-modal="false"
    >
      <div class="title">
        <img
          :src="
            getTheme == 'light'
              ? require('@/assets/images/members/title.png')
              : require('@/assets/images/members/title2.png')
          "
          alt
        />
      </div>
      <div class="renewal-box">
        <el-row :gutter="20" v-if="showQrCode">
          <el-col :span="8" v-for="(item, index) in memBersList" :key="index">
            <div
              class="item"
              v-if="index < 3"
              :class="{ active: index == active }"
            >
              <img
                class="icon"
                v-if="index == 0"
                src="@/assets/images/members/icon.png"
                alt
              />
              <div class="content">
                <p class="time">{{ item.Title }}</p>
                <p class="price">
                  活动价：
                  <span>{{ item.Price }}元</span>
                </p>
                <p class="original-price">
                  ￥{{ (item.Price * 3).toFixed(2) }}
                </p>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-else>
          <el-col :span="8" v-for="(item, index) in memBersList" :key="index">
            <div
              class="item"
              :class="{ active: index == active }"
              v-if="index < 3"
              @click="open(index)"
            >
              <!-- <img
                class="icon"
                :src="
                  index == 0
                    ? require('@/assets/images/members/icon.png')
                    : require('@/assets/images/members/mem_icon.png')
                "
                alt
              /> -->
              <img
                class="icon"
                :src="
                  index == 0 ? require('@/assets/images/members/icon.png') : ''
                "
                alt
              />

              <img
                class="icon"
                :src="
                  index !== 0 ? require('@/assets/images/members/jsq.png') : ''
                "
                alt
              />

              <div class="content">
                <div class="time">
                  <span>{{ item.Title }}</span>
                  <img
                    v-if="item.GiveDays > 0"
                    src="@/assets/images/members/give.png"
                    alt
                  />
                  <span v-if="item.GiveDays > 0" class="giveDays"
                    >{{ item.GiveDays }}天</span
                  >
                </div>
                <p class="price">
                  活动价：
                  <span>{{ item.Price }}元</span>
                </p>
                <p class="original-price">
                  ￥{{ (item.Price * 3).toFixed(2) }}
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row :gutter="20" class="pay-away">
        <el-col :span="8">
          <a
            v-if="Ali"
            href="javascript:;"
            class="a-pay1 pay"
            :class="{ active: payWay == 1 }"
            @click="changePayWay(1)"
          >
            <img src="@/assets/images/members/zfb.png" alt />支付宝支付
          </a>

          <a v-else href="javascript:;" class="a-pay1 pay">
            <img src="@/assets/images/members/zfb.png" alt />支付宝支付
          </a>
        </el-col>
        <el-col :span="8" v-if="WeChat">
          <!-- :class="[showQrCode ? 'active' : '', 'a-pay2 pay']" -->
          <a
            href="javascript:;"
            class="a-pay2 pay"
            :class="{ active: payWay == 2 }"
            @click="changePayWay(2)"
          >
            <img src="@/assets/images/members/wx.png" alt />微信支付（通道一）
          </a>
        </el-col>
        <el-col :span="8" v-if="paySwitch">
          <!-- :class="[showQrCode ? 'active' : '', 'a-pay2 pay']" -->
          <a
            href="javascript:;"
            class="a-pay2 pay"
            :class="{ active: payWay == 3 }"
            @click="changePayWay(3)"
          >
            <img src="@/assets/images/members/wx.png" alt />微信支付（通道二）
          </a>
        </el-col>
        <el-col :span="8" v-if="SaaS">
          <!-- :class="[showQrCode ? 'active' : '', 'a-pay2 pay']" -->
          <a
            href="javascript:;"
            class="a-pay2 pay"
            :class="{ active: payWay == 4 }"
            @click="changePayWay(4)"
          >
            <img src="@/assets/images/members/wx.png" alt />微信支付（通道三）
          </a>
        </el-col>
      </el-row>

      <div
        class="pl-box"
        v-clipboard:copy="OrderNo"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        <div>支付问题？</div>
        <img src="@/assets/img/server.gif" width="80px" alt="" />
        <div>专属客服快速处理</div>
      </div>

      <!-- <div v-if="showQrCode && paySwitch" class="qrCodeBox">
        <img v-if="qrCodeUrl" :src="qrCodeUrl" alt />
        <div class="ps">
          <p>请添加客服专人微信进行购买；</p>
          <p>需加收1元手续费</p>
          <el-button class="btn-service" @click="onLineService"
            >联系在线客服购买</el-button
          >
        </div>
      </div> -->

      <div>
        <div id="qrCode">
          <p class="ad">早买早享受，玩到就是赚到</p>
          <div class="qrCode-box">
            <canvas
              id="canvas"
              ref="canvas"
              v-if="(userInfo && userInfo.Level == 0) || payWay == 1"
            ></canvas>

            <div v-if="userInfo && userInfo.Level == 1 && payWay !== 1">
              <div
                style="
                  height: 166px;
                  color: #ccc;
                  font-weight: bold;
                  font-size: 24px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                已禁止使用
              </div>
            </div>
          </div>
        </div>
        <div class="agreement-box">
          <div
            style="margin-bottom: 10px"
            v-if="userInfo && userInfo.Level == 0"
          >
            <a
              href="javascript:;"
              style="font-size: 16px"
              v-if="payWay == 2 || payWay == 3 || payWay == 4"
              @click="getIpaynow"
              >若您已支付成功，页面未刷新，请点击<span
                style="color: #f02828; text-decoration: underline"
                >我已支付</span
              >
            </a>

            <p>
              应付金额：
              <span>{{ memberObj.Price }}元</span>
            </p>
            <el-checkbox
              class="agreement"
              name="type"
              v-model="checked"
              disabled
            ></el-checkbox>
            <a href="javascript:;" @click="linkTo" class="agreement"
              >阅读并同意《会员服务协议》</a
            >
          </div>

          <div
            v-if="userInfo && userInfo.Level == 1 && payWay !== 1"
            style="color: #20b0d6; font-size: 16px"
          >
            检测您提交过微信支付投诉，已禁止使用平台微信付款，建议用支付宝付款
          </div>
        </div>
        <!-- OrderNo !== localOrderNo &&  -->
      </div>
    </el-dialog>
    <!-- 禁用黑名单用户提示弹窗 -->
    <BlackListDialog ref="blacklist" :errorMessage="errorMessage" />

    <!-- 支付成功广告弹窗 -->
    <el-dialog
      custom-class="ad-dialog"
      :visible.sync="adDialog"
      width="30%"
      center
      v-if="adObj"
      :close-on-click-modal="false"
    >
      <img
        :src="adObj.ADImageUrl"
        width="100%"
        @click.stop="adToLink(adObj.ADOpenUrl)"
        alt=""
      />
    </el-dialog>

    <!-- 订单未支付弹窗 -->
    <el-dialog title="会员订单提示" :visible.sync="orderVisble">
      <el-form>
        <el-form-item label="会员订单号：" label-width="100px">
          {{ this.OrderNo }}
        </el-form-item>
        <div>检测到您的订单未支付，如有疑问点击联系客服</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderVisble = false">取 消</el-button>
        <el-button
          type="primary"
          v-clipboard:copy="OrderNo"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >联系客服</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetMemberPackage,
  CrateOrder,
  GetOrderPayState,
  GetPaymentSwitch,
  GetNavigationList,
  GetIpaynow,
} from "@/api";
import { mapGetters } from "vuex";
import QRCode from "qrcode";
import cMethods from "@/util/cMethods.js";
import BlackListDialog from "./BListDialog.vue";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  name: "MembersBuy",
  components: {
    BlackListDialog,
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "userInfo",
      "netBarId",
      "netBarName",
      "netBarVIP",
      "getIsAuth",
      "getTheme",
    ]),
  },
  data() {
    return {
      memBersList: [],
      isDialogShow: false,
      memberObj: {},
      payWay: 1, // 支付方式：1.支付宝支付  2.微信支付
      checked: true,
      active: 0,
      qrCode: "",
      timer: null,
      Ali: false,
      WeChat: false,
      SaaS: false,
      qrCodeUrl: "",
      showQrCode: false,
      paySwitch: false,
      errorMessage: "",
      adDialog: false,
      adObj: null,
      FromPlatform: "",
      OrderNo: "",
      // localOrderNo: "",
      orderVisble: false,
    };
  },
  // created() {
  //   eventBus.$on("membersBuy", (toggle) => {
  //     this.active = toggle;
  //     this.isShow = true;
  //     this._GetMemberPackage();
  //   });
  // },
  mounted() {
    this._GetPaymentSwitch();
  },
  methods: {
    async getIpaynow() {
      // if (this.localOrderNo === this.OrderNo) {
      //   this.isShowPayNow = true;
      // } else {
      //   this.localOrderNo = this.OrderNo;
      //   this.isShowPayNow = false;
      // }

      if (this.OrderNo && this.payWay && this.FromPlatform) {
        let type = "";
        if (this.payWay === 4) {
          this.FromPlatform = this.FromPlatform.split(",")[3];
          type = "银联商务";
        } else if (this.payWay === 3) {
          this.FromPlatform = this.FromPlatform.split(",")[2];
          type = "微信";
        } else if (this.payWay === 2) {
          this.FromPlatform = this.FromPlatform.split(",")[0];
          type = "现在支付";
        } else {
          this.FromPlatform = this.FromPlatform.split(",")[1];
          type = "支付宝";
        }

        let params = {
          orderId: this.OrderNo,
          fromPlatform: this.FromPlatform,
          type: type, // this.payWay == 1 ? "支付宝" : "微信",
        };
        let res = await GetIpaynow(params);
        if (res.StatusCode == 200) {
          if (res.Object == 0) {
            // 关闭弹窗
            this.isDialogShow = false;
            clearInterval(this.timer);

            this.$store.dispatch("_GetUserInfo");
            // 支付成功弹窗
            if (sessionStorage.getItem("adList")) {
              let adArr = JSON.parse(sessionStorage.getItem("adList"));
              if (adArr) {
                this.adObj = adArr.filter(
                  (item) => item.ADName === "支付成功广告"
                )[0];
                this.adDialog = true;
              }
            }
            // 会员支付成功
            if (this.$route.path == "/members") {
              this.$emit("changeShow", "false");
              // this.$router.push("/");
            } else {
              this.$emit("changeShow", "false", "start");
            }
            this.$statistic(["A", "买VIP会员页", "支付成功", "展现量"]);
          } else {
            this.orderVisble = true;
          }
        }

        // 是否绑定手机号
        let phone = sessionStorage.getItem("Phone");
        if (phone) {
          this.$statistic(["A", "买VIP会员页", "我已支付：" + phone, "展现量"]);
        }
      }
    },
    // 在线人工客服
    onLineService(e) {
      cMethods.OpenIeUrl(
        "http://www.mayidianjing.com/Content/customerService/xiaoneng.html"
      );
      this.$statistic(["B", "客服帮助", "点击", "联系在线客服"]);
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message({
        type: "success",
        message: "订单号已复制到剪切板！",
      });
      cMethods.OpenIeUrl(
        "http://www.mayidianjing.com/Content/customerService/xiaoneng.html"
      );
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
      this.$message({
        type: "error",
        message: "抱歉,复制失败！",
      });
    },
    // 获取微信二维码
    async _GetNavigationList() {
      let params = {
        type: 4,
      };
      let res = await GetNavigationList(params);
      if (res.StatusCode == 200) {
        this.qrCodeUrl = res.Object[0].ImgUrl;
      } else {
        this.errorMessage = res.Message;
      }
    },
    // 获取会员套餐列表
    async _GetPaymentSwitch() {
      let res = await GetPaymentSwitch();
      if (res.StatusCode == 200) {
        this.Ali = res.Object.Ali;
        this.WeChat = res.Object.WeChat;
        this.paySwitch = res.Object.WeChat1;
        this.SaaS = res.Object.SaaS;
        console.log("支付方式：", res.Object);
        if (this.Ali == false) {
          this.payWay = 2;
        }

        if (this.paySwitch) {
          this._GetNavigationList();
        }
      }
    },
    handleOpen() {
      this._GetMemberPackage();
    },
    // 获取会员套餐列表
    async _GetMemberPackage() {
      let res = await GetMemberPackage();
      if (res.StatusCode == 200) {
        this.memBersList = res.Object;
        this.memberObj = this.memBersList[this.active];
        this.$statistic(["A", "游戏详情页", "付款码", "展现量"]);
        if (this.memberObj) {
          this._BuyVipSetMeal();
        }
      }
    },
    // 开通会员弹窗
    open(index) {
      if (this.isLogin) {
        this.active = index;
        this.memberObj = this.memBersList[this.active];
        // 是否绑定手机号
        let phone = sessionStorage.getItem("Phone");
        if (phone) {
          if (this.getIsAuth && !this.userInfo.IDCard) {
            eventBus.$emit("showAuth");
            return false;
          }
          this._BuyVipSetMeal();
        } else {
          eventBus.$emit("showLoginPhone");
        }
      } else {
        eventBus.$emit("getQrCode");
      }
      this.$statistic(["A", "买VIP会员页", "付款码", "展现量"]);
    },
    // 购买会员套餐
    async _BuyVipSetMeal() {
      // 下单获取二维码
      if (this.memberObj) {
        if (this.Ali || this.WeChat || this.WeChat1 || this.SaaS) {
          let params = {
            ConsumerId: this.userInfo.ConsumerId,
            MemberPackageId: this.memberObj.Id,
            NetbarId: this.netBarId,
          };
          let res = await CrateOrder(params);
          console.log(res, res.Message);
          if (res.StatusCode == 400) {
            if (res.Message.indexOf("您当前支付超限，已禁止支付") > -1) {
              this.$alert(res.Message, "温馨提示", {
                confirmButtonText: "确定",
                showConfirmButton: false,
                callback: (action) => {},
              });
            } else {
              this.errorMessage = res.Message;
              this.$refs["blacklist"].blackListDialogShow();
            }
            return;
          }

          // 禁用黑名单
          if (res.data == "Error: Request failed with status code 400") {
            this.errorMessage = res.data.response.data.Message;
            this.$refs["blacklist"].blackListDialogShow();
            return;
          }

          // 正常用户
          if (res.StatusCode == 200) {
            if (this.payWay == 1) {
              this.orderCode = res.Object.AliPayUrl;
            }
            if (this.payWay == 2) {
              this.orderCode = res.Object.IpaynowUrl;
            }
            if (this.payWay == 3) {
              this.orderCode = res.Object.WeChatPayUrl;
            }
            if (this.payWay == 4) {
              this.orderCode = res.Object.SaaSUrl;
            }
            this.OrderNo = res.Object.OrderNo;
            if (this.orderCode) {
              if (this.orderCode !== "此用户禁用微信支付") {
                this.setQrCode(this.orderCode, this.OrderNo);
              }
            }
            this.FromPlatform = res.Object.FromPlatform;
          }
        }
      }
    },
    // 生成二维码
    async setQrCode(OrderCode, OrderNo) {
      // 显示支付二维码弹窗组件
      let canvas = this.$refs.canvas;
      QRCode.toCanvas(canvas, OrderCode, function (error) {
        if (error) console.error(error);
        // console.log("QRCode success!");
      });
      // 查看订单状态
      clearInterval(this.timer);
      this.timer = setInterval(async () => {
        let params = {
          orderId: OrderNo,
        };

        let res = await GetOrderPayState(params);
        if (res.StatusCode == 200) {
          if (res.Object == 0) {
            // 关闭弹窗
            this.isDialogShow = false;
            clearInterval(this.timer);

            this.$store.dispatch("_GetUserInfo");
            // 支付成功弹窗
            if (sessionStorage.getItem("adList")) {
              let adArr = JSON.parse(sessionStorage.getItem("adList"));
              if (adArr) {
                this.adObj = adArr.filter(
                  (item) => item.ADName === "支付成功广告"
                )[0];
                this.adDialog = true;
              }
            }
            // 会员支付成功
            if (this.$route.path == "/members") {
              this.$emit("changeShow", "false");
              // this.$router.push("/");
            } else {
              this.$emit("changeShow", "false", "start");
            }
            this.$statistic(["A", "买VIP会员页", "支付成功", "展现量"]);
          }
        }
      }, 3000);
    },
    // 切换支付方式
    changePayWay(index) {
      if (index == 1) {
        this.showQrCode = false;
        this.payWay = index;
        this._BuyVipSetMeal();
      }
      if (index == 2) {
        this.showQrCode = false;
        this.payWay = index;
        this._BuyVipSetMeal();
      }
      if (index == 3) {
        // this.active = 0;
        this.payWay = index;
        this.showQrCode = false;
        this._BuyVipSetMeal();
      }
      if (index == 4) {
        // this.active = 0;
        this.payWay = index;
        this.showQrCode = false;
        this._BuyVipSetMeal();
      }
    },
    // 弹出框关闭后触发
    closeDialog() {
      clearInterval(this.timer);
      this.timer = null;
      this.$emit("changeShow", "false");
    },
    // 广告跳转
    linkTo() {
      cMethods.OpenIeUrl("http://www.mayidianjing.com/Content/html/580tq.html");
    },
    // 登录成功弹窗跳转
    adToLink(url) {
      this.adDialog = false;
      this.$router.push(url);
    },
  },
  watch: {
    isShow(oldVal, newVal) {
      this.isDialogShow = this.isShow;
    },
  },
};
</script>

<style lang="scss" scoped>
.no-title-dialog1 {
  position: relative;
  .pl-box {
    width: 120px;
    text-align: center;
    position: absolute;
    right: 50px;
    bottom: 100px;
    line-height: 24px;
  }

  .title {
    text-align: center;
  }

  .renewal-box {
    padding: 40px 60px;

    .item.active {
      border: 1px solid #c2a36c;
    }

    .item {
      height: 256px;
      @include tag_bg_col();
      position: relative;
      cursor: pointer;
      text-align: center;

      .icon {
        position: absolute;
        top: -7px;
        left: -7px;
      }

      a {
        height: 256px;
        display: block;
        z-index: 9999;
      }

      .time {
        line-height: 25px;
        font-size: 28px;
        @include font_col3();
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 27px;
          height: 28px;
          margin: 0 10px;
        }

        .giveDays {
          font-size: 28px;
          color: #f02828;
        }
      }

      .price {
        font-size: 22px;
        font-weight: 500;
        color: #f02828;
        margin-bottom: 15px;

        span {
          font-size: 24px;
        }
      }

      .original-price {
        text-decoration: line-through;
        font-size: 16px;
        @include font_col9();
      }

      .text {
        height: 44px;
        line-height: 44px;

        img {
          width: 239px;
          height: 44px;
        }
      }
    }

    .item:hover {
      transform: scale(1.03);
      border: 1px solid #c2a36c;
    }

    .content {
      padding: 40px 0 30px 0;
    }
  }

  .renewal-box {
    padding: 20px 0 !important;

    .item {
      height: 166px !important;
      background: #f6f6f6;
      position: relative;
      cursor: pointer;
      text-align: center;

      .content {
        padding: 30px 0 20px 0;

        .time {
          margin-bottom: 20px;
        }
      }
    }

    .item.active {
      background: url("./../../assets/images/members/active.png") no-repeat;
      background-position: right bottom;
    }
  }

  .qrCodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    img {
      width: 204px;
      height: 204px;
      margin-right: 20px;
    }

    .ps {
      // padding-top: 20px;
      line-height: 40px;
      font-size: 20px;
      color: #f02828;
    }

    .btn-service {
      margin-top: 20px;
      border: 1px solid $red-col;
      color: $red-col;
    }

    .btn-service:hover {
      color: $white-col;
      background: $red-col;
    }
  }

  .a-pay1,
  .a-pay2 {
    // width: 200px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: block;
    text-align: center;
    border: 1px solid #f6f6f6;
    font-size: 16px;
    @include font_col3();
    @include tag_bg_col();

    img {
      margin-right: 10px;
    }
  }

  .a-pay1 {
    float: right;
  }

  .pay.active {
    border: 1px solid #20b0d6;
    background: url("./../../assets/images/members/10.png") no-repeat;
    background-position: right bottom;
  }

  #qrCode {
    text-align: center;
    padding: 10px 0;

    .ad {
      margin-bottom: 10px;
      color: red;
      font-size: 16px;
      // font-weight: bold;
    }

    .qrCode-box {
      width: 164px;
      height: 164px;
      display: inline-block;
      // border: 1px solid #d5d5d5;
      border: 1px solid rgba(155, 155, 156, 0.3);
    }
  }

  .agreement-box {
    text-align: center;
    @include font_col6();

    p {
      font-size: 18px;
      margin-bottom: 10px;

      span {
        font-size: 24px;
        color: #f22826;
      }
    }

    .agreement {
      margin-left: 10px;
      @include font_col6();
    }
  }
}
</style>